import { useEffect } from "react";

export default function JsonLd({ data }: { data: object }) {
  useEffect(() => {
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.text = JSON.stringify(data);
    s.dataset.readdyJson = "true";
    document.head.appendChild(s);
    return () => {
      if (s.parentNode) s.parentNode.removeChild(s);
    };
  }, []);

  return null;
}